import React from 'react';
import { X, Trophy } from 'lucide-react';
import { Crest } from './Tournaments';

export function computeChampion(fixtures, t, teamMap) {
  const finals = (fixtures || []).filter((f) => f.stage === 'knockout' && !f.next_fixture_id);
  if (!finals.length) return null;
  const fname = (t?.final_name || '').trim().toLowerCase();
  let main = finals.find((f) => (f.round_name || '').trim().toLowerCase() === fname);
  if (!main) main = [...finals].sort((a, b) => (b.round_order || 0) - (a.round_order || 0))[0];
  if (!main || main.status !== 'completed' || main.home_score === main.away_score) return null;
  const wid = main.home_score > main.away_score ? main.home_team_id : main.away_team_id;
  const tm = (teamMap || {})[wid];
  if (!tm) return null;
  return { id: wid, name: tm.name, logo: tm.logo, final_name: main.round_name || 'Final' };
}

const BURSTS = [
  { left: '18%', top: '28%', color: '#FFD700', delay: '0s' },
  { left: '72%', top: '22%', color: '#00BFFF', delay: '0.35s' },
  { left: '45%', top: '14%', color: '#FF3B30', delay: '0.7s' },
  { left: '82%', top: '58%', color: '#00D26A', delay: '1.05s' },
  { left: '14%', top: '62%', color: '#FF6BD6', delay: '1.4s' },
  { left: '55%', top: '70%', color: '#FFA500', delay: '1.75s' },
];

export function Celebration({ champion, onClose }) {
  if (!champion) return null;
  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center bg-black/90 backdrop-blur-sm overflow-hidden" data-testid="celebration-overlay">
      <style>{`
        @keyframes rc-spark { 0%{transform:rotate(var(--a)) translateY(0) scale(1);opacity:1} 100%{transform:rotate(var(--a)) translateY(-120px) scale(0.3);opacity:0} }
        @keyframes rc-pop { 0%{transform:scale(.6);opacity:0} 60%{transform:scale(1.08)} 100%{transform:scale(1);opacity:1} }
      `}</style>
      {BURSTS.map((b, i) => (
        <div key={i} className="absolute" style={{ left: b.left, top: b.top }}>
          {Array.from({ length: 16 }).map((_, j) => (
            <span key={j} style={{
              position: 'absolute', width: 7, height: 7, borderRadius: 9999, background: b.color,
              boxShadow: `0 0 8px ${b.color}`,
              '--a': `${(360 / 16) * j}deg`,
              animation: `rc-spark 1.3s ease-out ${b.delay} infinite`,
            }} />
          ))}
        </div>
      ))}
      <button data-testid="celebration-close" onClick={onClose}
        className="absolute top-5 right-5 w-11 h-11 rounded-full bg-white/10 hover:bg-white/20 flex items-center justify-center text-white z-10">
        <X size={24} />
      </button>
      <div className="text-center px-6 relative z-[1]" style={{ animation: 'rc-pop 0.8s ease-out' }}>
        <Trophy size={48} className="mx-auto text-[#FFD700] mb-3" style={{ filter: 'drop-shadow(0 0 16px #FFD70088)' }} />
        <p className="uppercase tracking-[0.35em] text-[#FFD700] text-xs sm:text-sm font-black mb-5">{champion.final_name} Champions</p>
        <div className="flex justify-center mb-5">
          <div className="rounded-full p-1.5 border-4 border-[#FFD700]" style={{ boxShadow: '0 0 30px #FFD70055' }}>
            <Crest name={champion.name} logo={champion.logo} size={96} />
          </div>
        </div>
        <h1 className="text-4xl sm:text-6xl font-black text-white leading-tight" data-testid="champion-name">{champion.name}</h1>
        <p className="text-gray-300 mt-3 text-sm sm:text-base">Tournament Winners</p>
      </div>
    </div>
  );
}
